<template>
  <div class="carousel-nav-pagination ms-auto d-flex justify-content-center align-items-center">
    <template v-if="hasSwiperEnabled">
      <div class="button-prev btn btn-primary rounded-5">
        <AppIcon icon="previous" />
      </div>
      <div
        class="pagination-container mx-2"
        :class="paginationClass"
        :style="paginationStyle"
      ></div>
      <div class="button-next btn btn-primary rounded-5">
        <AppIcon icon="next" />
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'CarouselNavAndPagination',
  props: {
    hasSwiperEnabled: {
      type: Boolean,
      required: true
    },
    paginationClass: {
      type: [String, Array, Object] as PropType<string | string[] | Record<string, boolean>>,
      default: ''
    },
    paginationStyle: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({})
    }
  }
})
</script>

<style lang="scss">
.carousel-nav-pagination {
  margin-top: 2em;
}
.pagination-container {
  display: grid;
  grid-template-columns: 3em auto 3em;
  justify-content: center;
}

.pagination-container.swiper-pagination-bullets {
  position: relative !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: auto !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;
  transform: none !important;

  .swiper-pagination-bullet {
    display: inline-block !important;
    width: 10px !important;
    height: 10px !important;
    background-color: #a4a4a4 !important;
    border-radius: 50%;
    cursor: pointer;
    margin: 0 !important;
    transition: all 0.3s ease;

    &.swiper-pagination-bullet-active {
      background: var(--dealer-primary-color, #0d6efd) !important;
      opacity: 1;
    }
  }
}
</style>
